<template>
  <div>
    <div
      v-for="notification in notifications"
      :key="notification.id"
      class="notification"
      :class="{
        unread: NOTIFICATION_STATE.UNREAD === notification.state,
        pending,
      }"
    >
      <div class="notification-text">
        <span class="notification-title">
          {{ notification.title }}
        </span>
        <span class="notification-description">
          {{ notification.description }}
        </span>
      </div>
      <div class="notification-actions">
        <template v-if="user.isAdmin()">
          <a
            v-if="NOTIFICATION_STATE.UNREAD === notification.state"
            title="Marquer comme lu"
            class="notification-action notification-read blue-text dropdown-close"
            @click="readNotif(notification.id)"
          >
            <i class="material-icons">remove_red_eye</i>
          </a>
        </template>
        <a
          v-else
          title="Voir le formulaire"
          class="notification-action notification-read blue-text dropdown-close"
          @click="readNotifAndRedirect(notification.id)"
        >
          <i class="material-icons">link</i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { NOTIFICATION_STATE } from '@/modules/notification/notification.data'
import { mapGetters } from 'vuex'

export default {
  name: 'NotificationBienetreList',
  props: {
    notifications: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      NOTIFICATION_STATE,
      pending: false,
    }
  },
  computed: {
    ...mapGetters('notification', ['notificationById']),
    ...mapGetters('user', ['user', 'isAdmin']),
  },
  methods: {
    async readNotif(id) {
      this.pending = true
      await this.$store.dispatch('notification/read', id)
      this.pending = false
    },
    async readNotifAndRedirect(id) {
      const notification = this.notificationById(id)
      if (!notification) {
        return
      }

      if (notification.getProperty('state') === NOTIFICATION_STATE.UNREAD) {
        await this.readNotif(id)
      }

      if (this.$route.name === 'user.profile') {
        return
      }

      return this.$router.push({ name: 'user.profile' })
    },
  },
}
</script>
